import React, { useEffect, useCallback, useState } from 'react'
import styled from 'styled-components'
import DPlayer from 'dplayer'
import useModal from '../../hooks/bakery/useModal'
import PlayModal from './PlayModal'

import { stopPropagation, isPC } from '../../utils/func'

const CardPlayer = styled.div`
  position: relative;
  .cover {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 372px;
    border-radius: 28px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    cursor: pointer;
    transition: background .2s linear;
    overflow: hidden;
  }
  .video .dplayer-controller {
    height: 0!important;
    overflow: hidden;
  }
  .dplayer-controller-mask {
    border-radius: 28px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    overflow: hidden;
  }
`
const IconImage = styled.div`
  display: block;
  width: 100%;
  height: 372px;
  border-radius: 28px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  .dplayer-controller-mask {
    height: 0;
    overflow: hidden;
  }
  .dplayer-video-wrap{
    background: transparent !important;
  }
`

export default function Player({player, isMyArtwork}: {player: any, isMyArtwork?: boolean}) {
  // 获取artwork id
  const [videoplay, setVideoplay] = useState<HTMLDivElement | null>(null)
  useEffect(() => {
    if (videoplay) {
      new DPlayer({
        container: videoplay,
        autoplay: isPC() ? false : true,
        mutex: true,
        video: {
          url: player.fileUrl
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoplay])

  const [artworkPlay] = useModal(
    <PlayModal
      video={player}
      isMyArtwork={isMyArtwork}
    />
  )

  const onPresentPlayer = useCallback(async (event: any) => {
    stopPropagation(event)
    artworkPlay()
  }, [artworkPlay])

  return (
    <CardPlayer>
      <IconImage ref={setVideoplay as any} className="video"></IconImage>
      <div className="cover" onClick={onPresentPlayer}>
        <img className="bgImg" src="images/artworks/dplayer.svg" alt=""/>
      </div>
    </CardPlayer>
  )
}
